import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SetPasswordPage } from '@/features/auth/SetPasswordPage';

const setPasswordSearch = z.object({
    /** The token from the emailed link. Missing means the link was mangled. */
    token: z.string().optional(),
});

export const Route = createFileRoute('/set-password')({
    validateSearch: (search) => setPasswordSearch.parse(search),
    component: SetPasswordPage,
});
